module.exports = new __parcel__URL__("select-wrike-csv.081d06f1.svg").toString();